import {
  AssortmentTag,
  CentralAssortmentFilterContextDTO,
} from '@retail/my-assortment/types';
import { GroupOption, ProductGroup, ProductGroupCount } from '@retail/products/types';
import { SupplierBase } from '@retail/suppliers/types';
import { useMemo } from 'react';
import { useFilters } from '@retail/products/hooks';
import { SelectedFilters } from '@retail/products/utils';
import { centralAssortmentsFilters, CentralAssortmentsFilters } from '@retail/my-assortment/utils';

export interface SelectedCentralAssortmentMemberViewFilters {
  selectedSupplier?: SupplierBase;
  selectedProductGroups?: ProductGroup[];
  selectedGroupNumbers: string[];
  searchQuery?: string;
  validFrom?: string | null;
  validTo?: string | null;
  selectedSubAssortments: AssortmentTag[];
  subAssortmentIds: string[];
  inAssortment: GroupOption;
  addedBy?: string | null;
  includeExpiredSubAssortments: boolean;
  isTagged: GroupOption;
}

export const useCentralAssortmentFilters = (filterOptions?: CentralAssortmentFilterContextDTO) => {

  const { filters, setFilters, updateFilter, resetFilters } = useFilters<CentralAssortmentsFilters>(centralAssortmentsFilters);


  const suppliers = useMemo(
    () => filterOptions?.suppliers?.map(SupplierBase.fromDto) ?? [],
    [filterOptions?.suppliers]
  );
  const productGroupHierarchy = useMemo(
    () => filterOptions?.productGroups?.map(ProductGroupCount.fromDto) ?? [],
    [filterOptions?.productGroups]
  );
  const productGroups = ProductGroupCount.flatten(productGroupHierarchy);
  const subAssortments = useMemo(
    () => filterOptions?.assortmentTags?.map(AssortmentTag.fromDTO) ?? [],
    [filterOptions?.assortmentTags]
  );

  const selectedSubAssortments = subAssortments.filter((tag) => filters.subAssortmentIds.includes(tag.id + ''));




  return {
    suppliers,
    productGroupHierarchy,
    productGroups,
    subAssortments,
    selectedSubAssortments,
    selectedFilters: filters satisfies SelectedFilters<CentralAssortmentsFilters>,
    setFilters,
    updateFilter,
    resetFilters,
  };
};
